import React from 'react';
import './App.scss';
import Header from './Components/common-header/Header';
import Footer from './Components/common-footer/Footer';
import Intro from './Components/Intro/Intro';
import Gallery from './Components/Gallery/Gallery';
import Copy1 from './Components/Copies/Copy1';
import Copy2 from './Components/Copies/Copy2';
import Copy3 from './Components/Copies/Copy3';
import Copy4 from './Components/Copies/Copy4';
import Copy5 from './Components/Copies/Copy5';
import Copy6 from './Components/Copies/Copy6';
import TheFitzpatrickScale from './Components/TheFitzpatrickScale/TheFitzpatrickScale';
import Citation from './Components/Citation/Citation';
import Poll from './Components/Poll/Poll';
import photoD1 from './assets/gallery/gallery1/d1.jpg';
import photoD2 from './assets/gallery/gallery1/d2.jpg';
import photoD3 from './assets/gallery/gallery1/d3.jpg';
import photoD4 from './assets/gallery/gallery1/d4.jpg';

import photoM1 from './assets/gallery/gallery1/m1.jpg';
import photoM2 from './assets/gallery/gallery1/m2.jpg';
import photoM3 from './assets/gallery/gallery1/m3.jpg';
import photoM4 from './assets/gallery/gallery1/m4.jpg';

const galleryData1 = {
  name: 'Anne Marre',
  photos: [
    {
      desktop: photoD1,
      mobile: photoM1,
      desc: `Sharing her eczema journey on social media has helped Anne Marre create a support system online.`,
      number: 1
    },
    {
      desktop: photoD2,
      mobile: photoM2,
      desc: `Anne Marre was diagnosed with eczema as a baby in the Philippines and had a difficult time growing up with the skin disease. “They just think you’re contagious or they just tease you because of how you look,” she recalls of other children.`,
      number: 2
    },
    {
      desktop: photoD3,
      mobile: photoM3,
      desc: `Being outdoors distracts Anne Marre from her eczema, but the sun can cause flare-ups. “For other people, the sun is actually a good thing, it helps with the healing,” she says. “But for my particular situation, my eczema gets triggered more.”`,
      number: 3
    },
    {
      desktop: photoD4,
      mobile: photoM4,
      desc: `Despite its challenges, eczema doesn’t stop Anne Marre from the outdoor activities she loves, like skateboarding. “Accepting it instead of questioning what's happening is basically a first step to healing for me,” she says of learning to live with eczema.`,
      number: 4
    }
  ]
};
const pollQuestions = [
  {
    qCopy: 'The amount of the world’s population that is affected by skin diseases is…',
    aCopy1: 'Skin diseases are the fourth most common cause of disease globally',
    answer: '33%',
    aCopy2: ', affecting almost ',
    aCopy3: '  of the world’s population.',
    sup: '19,20',
    aSup1: '19',
    aSup2: '20',
    choice1: '33',
    choice2: '12',
    index: 0
  },
  {
    qCopy: 'The average percentage of children with atopic dermatitis who have disrupted sleep is…',
    aCopy1: ' Sleep has been shown to be disrupted in up to ',
    answer: '60%',
    aCopy2: ' of children with atopic dermatitis.',
    sup: '13',
    choice1: '25',
    choice2: '60',
    index: 1
  },
  {
    qCopy:
      'The amount of dermatology trainees in the UK who thought they would become competent in treating skin conditions across ethnicities is…',
    aCopy1:
      ' of dermatology trainees in the UK thought they were or would become competent in treating skin conditions pertinent to the country’s ethnic population.',
    answer: '49%',
    sup: '21',
    choice1: '78',
    choice2: '49',
    index: 2
  }
];

function App() {
  return (
    <main className="App">
      <Header />
      <Intro />
      <Copy1 />
      <Poll pollQuestions={pollQuestions[0]} />
      <Copy2 />
      <div className="divider noMargin" />
      <TheFitzpatrickScale />
      <div className="divider noMarginBottom " />
      <Copy3 />
      <Poll pollQuestions={pollQuestions[1]} />
      <Copy4 />
      <Gallery galleryData1={galleryData1} />
      <Copy5 />
      <Poll pollQuestions={pollQuestions[2]} />
      <Copy6 />
      <div className="divider" />
      <Citation />
      <Footer />
    </main>
  );
}

export default App;
